import DateFormat from '../../shared/helpers/date-format'
let { slashed } = DateFormat

/**
 * Returns a string given whether an order is paid in full or not
 * @param dueAmount orderDetails due amount
 * @param paidInFullDate orderHistory paidInFullDate
 * @param products orderHistory products array.
 * @returns {string} payment status message
 */
export const orderDueAmountStrings = (dueAmount, paidInFullDate, products) => {
  let dueDate
  if (products.length > 0) {
    products.sort((a, b) => a.performanceDate - b.performanceDate)
    dueDate = products[0].performanceDateTime
  }
  if (dueAmount <= 0) {
    return 'This order is paid in full'
  } else if (paidInFullDate) {
    return 'Payment Incomplete'
  } else
    return `This order is not paid in full. Please complete payment before ${subtractDateTime(
      dueDate,
      14
    )} or your order will be cancelled.`
}

/**
 * Returns single order history object from the first order history api call
 * @param orderHistoryArray
 * @param orderId
 * @returns {{}}
 */
export const getOrderHistoryObject = (orderHistoryArray, orderId) => {
  let orderHistoryObject = {}
  orderHistoryArray.forEach(order => {
    if (order.odOrderNumber === orderId) {
      orderHistoryObject = order
    }
    return orderHistoryObject
  })
  return orderHistoryObject
}

/**
 * Subtracts the date by a given amount of days
 * @param date date from orderHistory object
 * @param days amount of days you'd like to subtract
 * @returns {*} new date with slashed date-format
 */
export const subtractDateTime = (date, days) => {
  let newDate = new Date(date)
  newDate.setDate(newDate.getDate() - days)
  return slashed(newDate)
}

/*
  Create an array of certain length and set the elements within it from
  start value to end value.
*/
const range = (start, end) => {
  let length = end - start + 1
  return Array.from({ length }, (_, idx) => idx + start)
}

export default {
  orderDueAmountStrings,
  getOrderHistoryObject,
  range,
  subtractDateTime
}
